import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		activeZap: {
			color: "#FC7434",
			fill: "currentColor",
		},
		container: {
			alignItems: "center",
			display: "flex",
		},
		star: {
			color: "#e0e0e0",
			fill: "#fff",
		},
	} satisfies Record<string, CSSObject>);
};
